import React from 'react';

import { TButtonSizes } from '@private/components';

import { Container, STATUS_VARIANTS } from 'components/Tags/Status/styled';
import { appReactMemo } from 'hocs';

export interface IStatus {
  children: React.ReactNode;
  className?: string;
  size?: 'xxs' | TButtonSizes;
  variant?: STATUS_VARIANTS;
}

const Status = ({
  children,
  className,
  size = 'sm',
  variant = STATUS_VARIANTS.NEUTRAL,
}: IStatus) => {
  return (
    <Container className={className} colorVariant={variant} size={size} variant='regular'>
      {children}
    </Container>
  );
};

export default appReactMemo(Status);
